export default __webpack_public_path__ + "static/media/openingscreenshot.58301065.png";